import request from "@/utils/http-util";
import {baseUrl} from "/env";

export function getResByDatasetIdApi(datasetId, datasetType, urlParams) {
    return request({
        url: baseUrl+`/dataset/getResByDatasetId?datasetId=${datasetId}&datasetType=${datasetType}`,
        method: 'post',
        data: urlParams
    })
}
